import { useCallback } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { ITableModeloEquipoEdit } from "../../../../../Interfaces/ListaVerificacion/ModeloEquipo/IModeloEquipo";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { UsePanelEquipoModeloEliminar } from "./UsePanelEquipoModeloEliminar";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { Warning24Filled } from "@fluentui/react-icons";
import { Body1, makeStyles } from "@fluentui/react-components";

export interface IPanelEquipoModeloEliminar extends IOpenPanel {
  item: ITableModeloEquipoEdit;
  reloadCombo?: () => void;
}

export const PanelEquipoModeloEliminar = (props: IPanelEquipoModeloEliminar) => {
  const styles = useStyles();

  const { request, DeleteEquipoModelo, loading, reset, mensaje, status, contentShow, loadprogress } = UsePanelEquipoModeloEliminar(props);

  const onRenderFooter = useCallback(
    () => (
      <PanelFooter
        texto="Eliminar"
        texto2={"Salir"}
        onClick={DeleteEquipoModelo}
        onDismiss={reset}
      />
    ),
    [request]
  );

  return (
    <PanelDrawer
      isOpen={props.isOpen}
      onDismiss={reset}
      textHeader={"Eliminar Modelo del Equipo"}
      status={status}
      mensaje={mensaje}
      loading={loading}
      onRenderFooter={onRenderFooter}
    >
      <div hidden={loading}>
        {!mensaje && (
          <>
            {!loadprogress && (
              <>
                {contentShow && (
                  <div className={styles.container}>
                    <div>
                      <Warning24Filled className={styles.warning} />
                    </div>
                    <div>
                      <Body1>
                        Este Modelo del Equipo será eliminado, ¿Desea eliminar el Modelo del Equipo: {props.item.equipo}?
                      </Body1>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </PanelDrawer>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  warning: {
    color: "#eaa300",
    width: "60px",
    height: "60px",
  },
});